import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/reviewer-profile/[reviewerId]/ReviewerProfilePageClient.js");
